import { getMovementsByJob } from '../redux/api';
import {
  getOpenWithdrawnMovements,
  getWithdrawnMovementLabel,
} from './withdrawnItemsUtils';

const CLOSING_JOB_STATUSES = ['Finished', 'Archived', 'Completed'];

export function isJobClosingStatus(status) {
  return CLOSING_JOB_STATUSES.includes(status);
}

export async function confirmOpenWithdrawnItemsBeforeJobClose(jobId, previousStatus, nextStatus) {
  if (!jobId || !isJobClosingStatus(nextStatus) || isJobClosingStatus(previousStatus)) {
    return true;
  }

  try {
    const response = await getMovementsByJob(jobId);
    const openMovements = getOpenWithdrawnMovements(response.data || []);
    if (openMovements.length === 0) return true;

    const summary = openMovements
      .slice(0, 5)
      .map((m) => `${getWithdrawnMovementLabel(m)} (${m.quantity} ${m.unit || 'kom'})`)
      .join('\n• ');
    const more = openMovements.length > 5 ? `\n… i još ${openMovements.length - 5}` : '';

    return window.confirm(
      `Upozorenje: za ovaj posao još uvek postoji ${openMovements.length} otvorena stavka povučene robe koja nije označena kao iskorišćena ni vraćena:\n\n• ${summary}${more}\n\nDa li želite ipak da zatvorite/arhivirate posao?`
    );
  } catch {
    return true;
  }
}
